module.exports = __webpack_public_path__ + "static/media/4.56387d2c.JPG";